import type {PropsWithChildren} from 'react';
import styles from './Paper.module.scss';

export interface PaperProps extends PropsWithChildren {
  elevation?: number;
  className?: string;
  role?: string;
  styleprop?: string;
}

function getShadow(level: number) {
  if (level >= 0 && level <= 24) {
    return styles[`shadow-${level}`];
  }
  return styles['shadow-1'];
}

/**
 * Use the elevation prop to establish hierarchy through the use of shadows. The Paper component's default elevation level is 1.
 * The prop accepts values from 0 to 24. The higher the number, the further away the Paper appears to be from its background.
 */
const Paper = (props: PaperProps): React.JSX.Element => {
  const {elevation = 1, className = '', styleprop = ''} = props;

  return (
    <div
      className={`${getShadow(elevation)} ${className} ${styleprop}`}
      {...props}
    >
      {props.children}
    </div>
  );
};

export {Paper};
